module.exports = __webpack_public_path__ + "static/media/request_quote_black_24dp.37afaa31.svg";